import { Button } from '@mui/material';
import { IntegrationsCardProps } from '@shared/models/integrations/integrations.model';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';

const IntegrationsCard: React.FC<IntegrationsCardProps> = ({
  item,
  onClick
}) => {
  const { t } = useTranslation();

  return (
    <div className="w-full p-5 border border-(--gray-alpha-600) rounded-[22px]">
      <div className="w-full flex justify-between items-start">
        <img
          src={item.image}
          alt={item.name}
          className="w-20 h-20 border border-(--gray-7) rounded-[20px] mb-4"
        />
        <Button
          variant="contained"
          className="min-w-25! py-1! text-[12px]!"
          onClick={() => onClick(item)}
        >
          {t('integrations_popup_button_connect')}
        </Button>
      </div>

      <h2 className="mb-1.25 text-[18px] font-semibold text-(--dark)">
        {item.name}
      </h2>

      <Tooltip title={item.description || ''} followCursor>
        <p className="h-10 text-sm font-normal text-(--gray-2) line-clamp-2 opacity-50">
          {item.description}
        </p>
      </Tooltip>
    </div>
  );
};

export default IntegrationsCard;
